export default __webpack_public_path__ + "static/cr-city-filter-gif-1435939a861381235897873bf211f9f5.mp4";